// extracted by mini-css-extract-plugin
export default {"section":"FilterSection_section__WQQcy","title":"FilterSection_title__spMOb"};